<template>
  <div>
    <enyo-select
      :id="fieldOptions.id"
      :options="internalOptions"
      :vModelValue="internalValue"
      :multiple="fieldOptions.multiple"
      :track-by="fieldOptions.trackBy || null"
      :label="fieldOptions.label || 'label'"
      :max="fieldOptions.max || null"
      :searchable="fieldOptions.searchable || false"
      :disabled="disabled"
      @input="updateSelected"
    >
    </enyo-select>
  </div>
</template>
<script>
import VueFormGenerator from "vue-form-generator";
import selectMixin from "@/mixins/selectMixin";

export default {
  mixins: [selectMixin, VueFormGenerator.abstractField],
  props: [], // 'schema', 'disabled', 'value' are in the abstract field
  data() {
    return {
      myModel: "",
    };
  },
  computed: {
    fieldOptions() {
      return this.schema.selectOptions || {};
    },

    customLabel() {
      if (
        typeof this.schema.fieldOptions !== "undefined" &&
        typeof this.schema.fieldOptions.customLabel !== "undefined" &&
        typeof this.schema.fieldOptions.customLabel === "function"
      ) {
        return this.schema.fieldOptions.customLabel;
      }
      // this will let the multiselect library use
      // the default behavior if customLabel is not specified
      return undefined;
    },

    dataUrl() {
      return this.url || this.fieldOptions.url;
    },
  },
  watch: {
    vModelValue(newValue, oldValue) {
      // fonction vide pour écraser le watcher du select mixin
      // this.setIncomingValue(newValue);
    },

    value(newValue, oldValue) {
      // console.log(" watcher value", newValue);
      this.setIncomingValue(newValue);
    },
  },

  methods: {
    addTag(newTag, id) {
      const { onNewTag } = this.fieldOptions;
      if (typeof onNewTag === "function") {
        onNewTag(newTag, id, this.options, this.value);
      }
    },

    // Sets the value from the the the v-model attribute
    setIncomingValue(value) {
      //  ne pas traiter une valeur undefined envoyée depuis le mounted du select mixin
      if (value === undefined) {
        return;
      }
      this.internalValue = value;
      if (Array.isArray(value)) {
        if (this.internalOptions && this.internalOptions.length) {
          this.internalValue = value.map((val) => {
            if (typeof val === "object") {
              return val;
            }
            return this.internalOptions.find((option) => {
              // const searchKey = typeof option === 'string' ? option : option[this.trackByComputed];
              if (typeof option === "object") {
                return option[this.trackByComputed] === val;
              }
              option == value;
            });
          });
        }
        return;
      }
      this.internalValue =
        this.internalOptions &&
        this.internalOptions.find((option) => {
          const searchKey =
            typeof option === "string" ? option : option[this.trackByComputed];
          return `${searchKey}` === `${value}`;
        });
      // this.myModel = this.internalValue;
    },

    updateSelected(value) {
      this.internalValue = value;
      if (!value || typeof value === "string" || typeof value === "number") {
        this.$emit("input", value);
        this.value = value;
      } else if (Array.isArray(value)) {
        const valueArray = value.map((item) =>
          this.trackByComputed && item[this.trackByComputed]
            ? item[this.trackByComputed]
            : item
        );
        this.$emit("input", valueArray);
        this.value = valueArray;
      } else {
        this.$emit("input", value[this.trackByComputed]);
        this.value = value[this.trackByComputed];
      }
    },
    onSearchChange(searchQuery, id) {
      const { onSearch } = this.fieldOptions;
      if (typeof onSearch === "function") {
        onSearch(searchQuery, id, this.options);
      }
    },
    onSelect(/* selectedOption, id */) {
      // console.log("onSelect", selectedOption, id);
    },
    onRemove(/* removedOption, id */) {
      // console.log("onRemove", removedOption, id);
    },
    onOpen(/* id */) {
      // console.log("onOpen", id);
    },
    onClose(/* value, id */) {
      // console.log("onClose", value, id);
    },
  },
  created() {
    // Check if the component is loaded globally
    if (!this.$root.$options.components.multiselect) {
      console.error(
        "'vue-multiselect' is missing. Please download from https://github.com/monterail/vue-multiselect and register the component globally!"
      );
    }
  },
  mounted() {
    App.select = this;
    this.setIncomingValue(this.value);
    this.loadRemoteEntities().then((ok) => {
      if (ok) {
        this.setIncomingValue(this.value);
      }
    });
  },
};
</script>
